import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Img } from '../../ui-kit/Img/Img.js';
import { TableInnerButton, } from '../../ui-kit/InnerTable/InnerTableButton.js';
import { renderButtonsSection } from '../../ui-kit/LinkButton/renderButtonsSection.js';
import { RichText } from '../../ui-kit/RichText/RichText.js';
import { Text } from '../../ui-kit/Text/Text.js';
const renderButtonsCellData = ({ buttons }) => renderButtonsSection(buttons, {
    buttonClassName: 'basis-0',
});
const renderLabelDescriptionCellData = ({ label, description }) => (_jsxs("div", { className: "space-y-2xs", children: [label ? (_jsx("div", { children: _jsx(Text, { size: "text-h6", children: label }) })) : null, description ? (_jsx("div", { className: "lg:text-l font-light text-xs", children: _jsx(Text, { color: "text-secondary-text", children: description }) })) : null] }));
const renderImgCellData = ({ image }) => (image?.src ? _jsx(Img, { image: image }) : null);
const renderRichTextCellData = ({ __html, isDotted = true }) => (_jsx("div", { className: "flex flex-col justify-between items-start text-h6", children: _jsx(RichText, { __html: __html, isDotted: isDotted, itemSize: "list-m" }) }));
const renderInnerTableCellData = ({ isVisible, displayTable, tableSource, pdfUrl, isOpen, }) => isVisible ? (_jsx(TableInnerButton, { className: "w-fit", isOpen: isOpen, onClick: () => {
        displayTable({ tableSource, pdfUrl });
    } })) : null;
export const EmbeddableCellData = {
    Buttons: renderButtonsCellData,
    Img: renderImgCellData,
    RichText: renderRichTextCellData,
    LabelDescription: renderLabelDescriptionCellData,
    Table: renderInnerTableCellData,
};
//# sourceMappingURL=EmbeddableCellData.js.map